// import React, { useEffect, useState, useContext, useRef } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import PurchaseInvoice from "../../styles/PurchaseInvoice.css"
// import {
//   Card,
//   CardBody,
//   Col,
//   Form,
//   Row,
//   Input,
//   Label,
//   Button,
//   CustomInput,
//   Modal,
//   ModalHeader,
//   ModalBody,
// } from "reactstrap";

// import Select from "react-select";
// import {
//   CreateCustomerList,
//   _Get,
//   _PostSave,
// } from "../../ApiEndPoint/ApiCalling";

// import UserContext from "../../context/Context";
// import { PurchaseGstCalculation } from "./PurchaseGstCalculation";
// import {
//   Purchase_Direct_Complete,
//   PurchaseProductList_Product,
// } from "../../ApiEndPoint/Api";

// import { Edit } from "react-feather";
// import axiosConfig from "../../AxiosConfig"
// const CreatePurchaseInvoice = () => {
//   const navigate = useNavigate();
//   const Context = useContext(UserContext);

//   const [product, setProduct] = useState([
//     {
//       productId: "",
//       qty: 1,
//       price: "",
//       basicPrice: "",
//       gstPercentage: 0,
//       taxableAmount: 0,
//       sgstRate: 0,
//       cgstRate: 0,
//       igstRate: 0,
//       grandTotal: 0,
//     },
//   ]);

//   const [Party, setParty] = useState({});
//   const [PartyId, setPartyId] = useState("");
//   const [PartyList, setPartyList] = useState([]);
//   const [ProductList, setProductList] = useState([]);
//   const [GSTData, setGSTData] = useState({});
//   const [Charges, setCharges] = useState(0);
//   const [orderDate, setOrderDate] = useState("");
//   const [modal, setModal] = useState(false);
//   const [extraCharges, setExtraCharges] = useState({});
//   const [Loading, setLoading] = useState(false);
//   const [UserInfo, setUserInfo] = useState({});
//   const [LandedPrice, setLandedPrice] = useState({});

//   const multiselectRefs = useRef([]);

//   // ✅ Sync refs with products
//   useEffect(() => {
//     multiselectRefs.current = product.map(
//       (_, i) => multiselectRefs.current[i] || React.createRef()
//     );
//   }, [product]);

//   // ✅ GST Calculation optimized
//   useEffect(() => {
//     const gstdetails = PurchaseGstCalculation(Party, product, Context, Charges);
//     setGSTData(gstdetails);
//   }, [Party, product, Charges]);

//   useEffect(() => {

//     const fetchData = async () => {

//       const user = JSON.parse(localStorage.getItem("userData"));

//       setUserInfo(user);

//       let id =
//         user?.rolename?.roleName === "SuperAdmin"
//           ? user._id
//           : user.created_by;

//       const today = new Date().toISOString().split("T")[0];

//       setOrderDate(today);

//       try {

//         // PRODUCTS
//         const productRes = await axiosConfig.get(`/product/view-product-purchase/${user.database}`)
//         debugger
//         const formattedProducts = productRes?.data?.Product?.map((item) => ({
//           label: item.Product_Title,
//           value: item._id,
//           data: item,
//         }));

//         setProductList(formattedProducts || []);

//         // CUSTOMERS
//         const customerRes = await CreateCustomerList(
//           id,
//           user?.database
//         );

//         const formattedParty = customerRes?.Customer?.map((item) => ({
//           label: item.CompanyName,
//           value: item._id,
//           data: item,
//         }));

//         setPartyList(formattedParty || []);



//       } catch (err) {

//         console.log("Fetch Error", err);

//       }
//     };

//     fetchData();

//   }, []);

//   // ✅ Party select
//   const handleSelectionParty = (list, item) => {
//     setParty(item);
//     setPartyId(item._id);
//   };

//   // ✅ Product select
//   const handleSelection = (selected, index) => {

//     const item = selected?.data;

//     if (!item) return;

//     const updated = [...product];

//     updated[index] = {
//       ...updated[index],

//       productId: item._id,

//       productData: item,

//       Product_Title: item.Product_Title,

//       HSN_Code: item.HSN_Code,

//       warehouseName:
//         item?.warehouse?.warehouseName || "",

//       basicPrice:
//         Number(item.Product_MRP || 0),

//       gstPercentage:
//         Number(item.GSTRate || 0),

//       qty: 1,

//       GrossQty: 1,

//       taxableAmount:
//         Number(item.Product_MRP || 0),
//     };

//     setProduct(updated);
//   };

//   // ✅ Qty / price change
//   const handleChange = (e, index) => {
//     const { name, value } = e.target;
//     if (Number(value) !== 0) {
//       const updated = [...product];
//       updated[index][name] = Number(value);
//       setProduct(updated);
//     }
//   };

//   // ✅ Add product row
//   const addMoreProduct = () => {
//     setProduct([
//       ...product,
//       {
//         productId: "",
//         qty: 1,
//         basicPrice: "",
//       },
//     ]);
//   };

//   // ✅ Remove row
//   const removeProduct = (i) => {
//     const updated = product.filter((_, index) => index !== i);
//     setProduct(updated);
//   };

//   // ✅ Submit
//   const submitHandler = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const payload = {
//       userId: UserInfo?._id,
//       partyId: PartyId,
//       orderItems: product,
//       grandTotal: GSTData?.Tax?.GrandTotal,
//       date: orderDate,
//       ...extraCharges,
//     };

//     try {
//       await _PostSave(Purchase_Direct_Complete, payload);
//       alert("Purchase Order Completed");
//       navigate(-1);
//     } catch (err) {
//       alert("Error");
//     }

//     setLoading(false);
//   };
//   const HandleUpdatePurchase = (e) => {
//     const { name, value } = e.target;

//     setExtraCharges((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };
//   return (
//     <Card className="purchase-card">
//       <CardBody>

//         {/* Header */}
//         <div className="header">
//           <h2>Create Purchase Order</h2>
//           <Button color="danger" onClick={() => navigate(-1)}>Back</Button>
//         </div>

//         {/* Top Row */}
//         <Row className="mb-2">
//           <Col md="4">
//             <Label>Choose Party *</Label>

//             <Select
//               options={PartyList}

//               value={
//                 PartyList.find(
//                   (p) => p.value === PartyId
//                 ) || null
//               }

//               getOptionLabel={(option) => option.label}

//               getOptionValue={(option) => option.value}

//               onChange={(selected) => {

//                 console.log("SELECTED PARTY", selected);

//                 setParty(selected?.data || {});
//                 setPartyId(selected?.value || "");
//               }}

//               placeholder="Select Party"
//               isClearable
//             />
//           </Col>

//           <Col md="4">
//             <Label>Invoice Date *</Label>
//             <Input
//               type="date"
//               value={orderDate}
//               onChange={(e) => setOrderDate(e.target.value)}
//             />
//           </Col>

//           <Col md="4">
//             <Label>Coolie and Cartage</Label>
//             <Input
//               type="number"
//               value={Charges}
//               onChange={(e) => setCharges(Number(e.target.value))}
//             />
//           </Col>
//         </Row>

//         {/* Product Row */}
//         {product.map((item, index) => (
//           <Row key={index} className="product-row align-items-end">

//             <Col md="3">
//               <Label>Choose Product *</Label>
//               <Select
//                 options={ProductList}

//                 value={
//                   ProductList.find(
//                     (p) => p.value === item.productId
//                   ) || null
//                 }

//                 getOptionLabel={(option) => option.label}

//                 getOptionValue={(option) => option.value}

//                 onChange={(selected) =>
//                   handleSelection(selected, index)
//                 }

//                 placeholder="Select Product"
//                 isClearable
//               />
//             </Col>

//             <Col md="1">
//               <Label>Warehouse</Label>
//               <Input value={item.warehouseName || ""} disabled />
//             </Col>

//             <Col md="1">
//               <Label>HSN</Label>
//               <Input value={item.HSN_Code || ""} disabled />
//             </Col>

//             <Col md="1">
//               <Label>Gross Qty</Label>
//               <Input
//                 type="number"
//                 value={item.GrossQty || ""}
//                 onChange={(e) => handleChange(e, index)}
//               />
//             </Col>

//             <Col md="1">
//               <Label>Net Qty</Label>
//               <Input
//                 type="number"
//                 name="qty"
//                 value={item.qty}
//                 onChange={(e) => handleChange(e, index)}
//               />
//             </Col>

//             <Col md="1">
//               <Label>Tax %</Label>
//               <Input value={item.gstPercentage || 0} disabled />
//             </Col>

//             <Col md="1">
//               <Label>Basic Price</Label>
//               <Input
//                 type="number"
//                 name="basicPrice"
//                 value={item.basicPrice}
//                 onChange={(e) => handleChange(e, index)}
//               />
//             </Col>

//             <Col md="1">
//               <Label>Basic Total</Label>
//               <Input
//                 value={item.taxableAmount?.toFixed(2) || 0}
//                 disabled
//               />
//             </Col>

//             <Col md="1">
//               {index !== 0 && (
//                 <Button color="danger" onClick={() => removeProduct(index)}>X</Button>
//               )}
//             </Col>

//           </Row>
//         ))}

//         {/* Add Button */}
//         <div className="text-end mt-2">
//           <Button color="primary" onClick={addMoreProduct}>+</Button>
//         </div>

//         {/* Bottom Section */}
//         <Row className="mt-3">

//           {/* Left Form */}
//           <Col md="6">
//             <Row>
//               <Col md="6">
//                 <Label>Invoice Number</Label>
//                 <Input name="invoiceId" onChange={HandleUpdatePurchase} />
//               </Col>

//               <Col md="6">
//                 <Label>Builty Number</Label>
//                 <Input name="BuiltyNumber" onChange={HandleUpdatePurchase} />
//               </Col>

//               <Col md="6">
//                 <Label>Dispatch Date</Label>
//                 <Input type="date" name="DispatchDate" onChange={HandleUpdatePurchase} />
//               </Col>

//               <Col md="6">
//                 <Label>No of Packages</Label>
//                 <Input type="number" name="NoOfPackage" onChange={HandleUpdatePurchase} />
//               </Col>

//               <Col md="6">
//                 <Label>Transporter</Label>
//                 <Input type="select" name="transporterId" onChange={HandleUpdatePurchase}>
//                   <option>----Select----</option>
//                 </Input>
//               </Col>

//               <Col md="6">
//                 <Label>Vehicle Number</Label>
//                 <Input name="vehicleNo" onChange={HandleUpdatePurchase} />
//               </Col>
//             </Row>
//           </Col>

//           {/* Right Summary */}
//           <Col md="6" className="d-flex justify-content-end">
//             <div className="summary-box">
//               <div>Basic Total: {GSTData?.Tax?.Amount || 0}</div>
//               <div>Charges: {Charges || 0}</div>
//               <div>SGST: {GSTData?.Tax?.SgstTotal || 0}</div>
//               <div>CGST: {GSTData?.Tax?.CgstTotal || 0}</div>
//               <div>RoundOff: {GSTData?.Tax?.RoundOff || 0}</div>
//               <hr />
//               <h5>Grand Total: {GSTData?.Tax?.GrandTotal || 0}</h5>
//             </div>
//           </Col>
//         </Row>

//         {/* Submit */}
//         <div className="text-center mt-3">
//           <Button color="primary" type="submit">
//             Submit
//           </Button>
//         </div>

//       </CardBody>
//     </Card>
//   );
// };

// export default CreatePurchaseInvoice;







import React, {
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";

import { useNavigate } from "react-router-dom";

import {
  Card,
  CardBody,
  Col,
  Form,
  Row,
  Input,
  Label,
  Button,
} from "reactstrap";

import Select from "react-select";

import {
  CreateCustomerList,
  _PostSave,
} from "../../ApiEndPoint/ApiCalling";

import UserContext from "../../context/Context";

import { PurchaseGstCalculation } from "./PurchaseGstCalculation";

import {
  Purchase_Direct_Complete,
} from "../../ApiEndPoint/Api";

import axiosConfig from "../../AxiosConfig";

import "../../styles/PurchaseInvoice.css";

const CreatePurchaseInvoice = () => {
  const navigate = useNavigate();
  const Context = useContext(UserContext);

  // =====================================================
  // PRODUCT STATE
  // =====================================================

  const [product, setProduct] = useState([
    {
      productId: "",
      productData: null,

      Product_Title: "",
      HSN_Code: "",
      warehouseName: "",

      qty: 1,
      GrossQty: 1,

      price: 0,
      basicPrice: 0,

      gstPercentage: 0,

      taxableAmount: 0,
landedCost:0,
      sgstRate: 0,
      cgstRate: 0,
      igstRate: 0,

      sgstAmount: 0,
      cgstAmount: 0,
      igstAmount: 0,
    },
  ]);

  // =====================================================
  // PARTY
  // =====================================================

  const [Party, setParty] = useState({});
  const [PartyId, setPartyId] = useState("");

  const [PartyList, setPartyList] = useState([]);
  const [ProductList, setProductList] = useState([]);
  const [TransporterList, setTransporterList] = useState([]);
  // =====================================================
  // GST
  // =====================================================

  const [GSTData, setGSTData] = useState({
    gstDetails: [],
    Tax: {
      Amount: 0,
      SgstTotal: 0,
      CgstTotal: 0,
      IgstTotal: 0,
      Charges: 0,
      RoundOff: 0,
      GrandTotal: 0,
    },
  });

  // =====================================================
  // OTHER STATES
  // =====================================================

  const [Charges, setCharges] = useState(0);
  const [orderDate, setOrderDate] = useState("");
  const [extraCharges, setExtraCharges] = useState({});
  const [Loading, setLoading] = useState(false);
  const [UserInfo, setUserInfo] = useState({});

  const multiselectRefs = useRef([]);

  // =====================================================
  // SYNC REFS
  // =====================================================

  useEffect(() => {
    multiselectRefs.current = product.map(
      (_, i) =>
        multiselectRefs.current[i] ||
        React.createRef()
    );
  }, [product]);

  // =====================================================
  // GST CALCULATION
  // =====================================================

  useEffect(() => {
    const gstdetails = PurchaseGstCalculation(
      Party,
      product,
      Context,
      Charges
    );

    console.log("GST DETAILS =>", gstdetails);

    setGSTData(gstdetails);
  }, [Party, product, Context, Charges]);

  // =====================================================
  // FETCH PARTY + PRODUCT
  // =====================================================

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(
          localStorage.getItem("userData")
        );

        if (!user) return;

        setUserInfo(user);

        const id =
          user?.rolename?.roleName === "SuperAdmin"
            ? user._id
            : user.created_by;

        // DATE

        const today = new Date()
          .toISOString()
          .split("T")[0];

        setOrderDate(today);

        // =================================================
        // PRODUCTS
        // =================================================

        const productRes =
          await axiosConfig.get(
            `/product/view-product-purchase/${user.database}`
          );

        const formattedProducts =
          productRes?.data?.Product?.map((item) => ({
            label: item.Product_Title,
            value: item._id,
            data: item,
          })) || [];

        setProductList(formattedProducts);
        const transporterRes = await axiosConfig.get(
          `/transporter/view-transporter/${user.database}`
        );

        console.log(
          "TRANSPORTER RESPONSE =>",
          transporterRes?.data
        );

        const formattedTransporters =
          transporterRes?.data?.Transporter?.map((item) => ({
            label:
              item?.companyName ||
              item?.name ||
              "Unnamed Transporter",

            value: item?._id,

            data: item,
          })) || [];

        setTransporterList(formattedTransporters);
        // =================================================
        // CUSTOMERS
        // =================================================

        const customerRes =
          await CreateCustomerList(
            id,
            user?.database
          );

        const formattedParty =
          customerRes?.Customer?.map((item) => ({
            label: item.CompanyName,
            value: item._id,
            data: item,
          })) || [];

        setPartyList(formattedParty);
      } catch (err) {
        console.log(
          "Fetch Error",
          err
        );
      }
    };

    fetchData();
  }, []);

  // =====================================================
  // PARTY SELECT
  // =====================================================

  const handlePartyChange = (selected) => {
    console.log(
      "SELECTED PARTY =>",
      selected
    );

    setParty(
      selected?.data || {}
    );

    setPartyId(
      selected?.value || ""
    );
  };

  // =====================================================
  // PRODUCT SELECT
  // =====================================================

  const handleSelection = (
    selected,
    index
  ) => {
    const item =
      selected?.data;

    if (!item) {
      return;
    }

    const updated = [
      ...product,
    ];

    const price = Number(
      item.Product_MRP || 0
    );

    const gst = Number(
      item.GSTRate || 0
    );

    const qty = 1;

    const taxableAmount =
      price * qty;

    updated[index] = {
      ...updated[index],

      // PRODUCT
      productId: item._id,

      productData: item,

      Product_Title:
        item.Product_Title || "",

      HSN_Code:
        item.HSN_Code || "",

      warehouseName:
        item?.warehouse?.warehouseName ||
        "",

      // QUANTITY
      qty: qty,

      GrossQty: qty,

      // PRICE
      // IMPORTANT
      price: price,

      basicPrice: price,

      // GST
      gstPercentage: gst,

      // TAXABLE
      taxableAmount:
        taxableAmount,

      // RATES
      cgstRate: gst / 2,

      sgstRate: gst / 2,

      igstRate: gst,

      // AMOUNTS
      cgstAmount: 0,

      sgstAmount: 0,

      igstAmount: 0,
    };

    setProduct(updated);
  };

  // =====================================================
  // PRODUCT CHANGE
  // =====================================================

  const handleChange = (
    e,
    index
  ) => {
    const {
      name,
      value,
    } = e.target;

    const updated = [
      ...product,
    ];

    const numericValue =
      Number(value);

    updated[index] = {
      ...updated[index],

      [name]:
        numericValue,
    };

    // -----------------------------------------------
    // BASIC PRICE CHANGE
    // -----------------------------------------------

    if (
      name === "basicPrice"
    ) {
      updated[index].price =
        numericValue;
    }

    // -----------------------------------------------
    // QTY
    // -----------------------------------------------

    if (
      name === "qty"
    ) {
      updated[index].qty =
        numericValue;
    }

    // -----------------------------------------------
    // TAXABLE AMOUNT
    // -----------------------------------------------

    const qty =
      Number(
        updated[index]
          .qty || 0
      );

    const basicPrice =
      Number(
        updated[index]
          .basicPrice || 0
      );

    const gstRate =
      Number(
        updated[index]
          .gstPercentage || 0
      );

    const taxableAmount =
      qty * basicPrice;

    updated[index]
      .taxableAmount =
      taxableAmount;

    // -----------------------------------------------
    // CHECK STATE
    // -----------------------------------------------

    const companyState =
      Context?.CompanyDetails
        ?.state ||
      Context?.CompanyDetails
        ?.State ||
      "";

    const partyState =
      Party?.state ||
      Party?.State ||
      "";

    const isSameState =
      companyState &&
      partyState &&
      companyState
        .toString()
        .toLowerCase() ===
      partyState
        .toString()
        .toLowerCase();

    // -----------------------------------------------
    // GST
    // -----------------------------------------------

    if (isSameState) {
      updated[index]
        .cgstAmount =
        Number(
          (
            taxableAmount *
            (gstRate / 2) /
            100
          ).toFixed(2)
        );

      updated[index]
        .sgstAmount =
        Number(
          (
            taxableAmount *
            (gstRate / 2) /
            100
          ).toFixed(2)
        );

      updated[index]
        .igstAmount = 0;
    } else {
      updated[index]
        .cgstAmount = 0;

      updated[index]
        .sgstAmount = 0;

      updated[index]
        .igstAmount =
        Number(
          (
            taxableAmount *
            gstRate /
            100
          ).toFixed(2)
        );
    }

    setProduct(updated);
  };

  // =====================================================
  // ADD PRODUCT
  // =====================================================

  const addMoreProduct = () => {
    setProduct([
      ...product,

      {
        productId: "",
        productData: null,

        Product_Title: "",
        HSN_Code: "",
        warehouseName: "",

        qty: 1,
        GrossQty: 1,

        price: 0,
        basicPrice: 0,

        gstPercentage: 0,

        taxableAmount: 0,

        sgstRate: 0,
        cgstRate: 0,
        igstRate: 0,

        sgstAmount: 0,
        cgstAmount: 0,
        igstAmount: 0,
      },
    ]);
  };

  // =====================================================
  // REMOVE PRODUCT
  // =====================================================

  const removeProduct = (
    index
  ) => {
    const updated =
      product.filter(
        (_, i) =>
          i !== index
      );

    setProduct(updated);
  };

  // =====================================================
  // EXTRA CHARGES / OTHER DETAILS
  // =====================================================

  const HandleUpdatePurchase = (
    e
  ) => {
    const {
      name,
      value,
    } = e.target;

    setExtraCharges(
      (prev) => ({
        ...prev,
        [name]: value,
      })
    );
  };

  // =====================================================
  // SUBMIT
  // =====================================================

  const submitHandler = async (
    e
  ) => {
    e.preventDefault();

    if (!PartyId) {
      alert(
        "Please select Party"
      );
      return;
    }

    const validProducts =
      product.filter(
        (item) =>
          item.productId
      );

    if (
      validProducts.length ===
      0
    ) {
      alert(
        "Please select at least one product"
      );
      return;
    }

    setLoading(true);

    const payload = {
      userId:
        UserInfo?._id,

      partyId:
        PartyId,

      orderItems:
        product,

      grandTotal:
        GSTData?.Tax
          ?.GrandTotal || 0,

      date:
        orderDate,

      ...extraCharges,
    };

    console.log(
      "PURCHASE PAYLOAD =>",
      payload
    );

    try {
      await _PostSave(
        Purchase_Direct_Complete,
        payload
      );

      alert(
        "Purchase Order Completed"
      );

      navigate(-1);
    } catch (err) {
      console.log(
        "Submit Error =>",
        err
      );

      alert(
        "Error while creating purchase order"
      );
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // UI
  // =====================================================

  return (
    <Card className="purchase-card">
      <CardBody>

        <Form
          onSubmit={
            submitHandler
          }
        >

          {/* =================================================
              HEADER
          ================================================= */}

          <div className="header">

            <h2>
              Create Purchase Order
            </h2>

            <Button
              color="danger"
              type="button"
              onClick={() =>
                navigate(-1)
              }
            >
              Back
            </Button>

          </div>

          {/* =================================================
              TOP ROW
          ================================================= */}

          <Row className="mb-2">

            {/* PARTY */}

            <Col md="4">

              <Label>
                Choose Party *
              </Label>

              <Select
                options={
                  PartyList
                }

                value={
                  PartyList.find(
                    (p) =>
                      p.value ===
                      PartyId
                  ) || null
                }

                getOptionLabel={(
                  option
                ) =>
                  option.label
                }

                getOptionValue={(
                  option
                ) =>
                  option.value
                }

                onChange={
                  handlePartyChange
                }

                placeholder="Select Party"

                isClearable
              />

            </Col>

            {/* DATE */}

            <Col md="4">

              <Label>
                Invoice Date *
              </Label>

              <Input
                type="date"
                value={
                  orderDate
                }
                onChange={(
                  e
                ) =>
                  setOrderDate(
                    e.target
                      .value
                  )
                }
              />

            </Col>

            {/* CHARGES */}

            <Col md="4">

              <Label>
                Coolie and Cartage
              </Label>

              <Input
                type="number"
                value={
                  Charges
                }
                onChange={(
                  e
                ) =>
                  setCharges(
                    Number(
                      e.target
                        .value
                    )
                  )
                }
              />

            </Col>

          </Row>

          {/* =================================================
              PRODUCTS
          ================================================= */}

          {product.map(
            (
              item,
              index
            ) => (

              <Row
                key={index}
                className="product-row align-items-end mb-2"
              >

                {/* PRODUCT */}

                <Col md="3">

                  <Label>
                    Choose Product *
                  </Label>

                  <Select
                    options={
                      ProductList
                    }

                    value={
                      ProductList.find(
                        (p) =>
                          p.value ===
                          item.productId
                      ) || null
                    }

                    getOptionLabel={(
                      option
                    ) =>
                      option.label
                    }

                    getOptionValue={(
                      option
                    ) =>
                      option.value
                    }

                    onChange={(
                      selected
                    ) =>
                      handleSelection(
                        selected,
                        index
                      )
                    }

                    placeholder="Select Product"

                    isClearable
                  />

                </Col>

                {/* WAREHOUSE */}

                <Col md="1">

                  <Label>
                    Warehouse
                  </Label>

                  <Input
                    value={
                      item.warehouseName ||
                      ""
                    }
                    disabled
                  />

                </Col>

                {/* HSN */}

                <Col md="1">

                  <Label>
                    HSN
                  </Label>

                  <Input
                    value={
                      item.HSN_Code ||
                      ""
                    }
                    disabled
                  />

                </Col>

                {/* GROSS QTY */}

                <Col md="1">

                  <Label>
                    Gross Qty
                  </Label>

                  <Input
                    type="number"
                    name="GrossQty"
                    value={
                      item.GrossQty ||
                      ""
                    }
                    onChange={(
                      e
                    ) =>
                      handleChange(
                        e,
                        index
                      )
                    }
                  />

                </Col>

                {/* NET QTY */}

                <Col md="1">

                  <Label>
                    Net Qty
                  </Label>

                  <Input
                    type="number"
                    name="qty"
                    value={
                      item.qty
                    }
                    onChange={(
                      e
                    ) =>
                      handleChange(
                        e,
                        index
                      )
                    }
                  />

                </Col>

                {/* GST */}

                <Col md="1">

                  <Label>
                    Tax %
                  </Label>

                  <Input
                    value={
                      item.gstPercentage ||
                      0
                    }
                    disabled
                  />

                </Col>

                {/* BASIC PRICE */}

                <Col md="1">

                  <Label>
                    Basic Price
                  </Label>

                  <Input
                    type="number"
                    name="basicPrice"
                    value={
                      item.basicPrice
                    }
                    onChange={(
                      e
                    ) =>
                      handleChange(
                        e,
                        index
                      )
                    }
                  />

                </Col>

                {/* BASIC TOTAL */}

                <Col md="1">

                  <Label>
                    Basic Total
                  </Label>

                  <Input
                    value={Number(
                      item.taxableAmount ||
                      0
                    ).toFixed(2)}
                    disabled
                  />

                </Col>

                {/* REMOVE */}

                <Col md="1">

                  {index !==
                    0 && (
                      <Button
                        color="danger"
                        type="button"
                        onClick={() =>
                          removeProduct(
                            index
                          )
                        }
                      >
                        X
                      </Button>
                    )}

                </Col>

              </Row>
            )
          )}

          {/* =================================================
              ADD PRODUCT
          ================================================= */}

          <div className="text-end mt-2">

            <Button
              color="primary"
              type="button"
              onClick={
                addMoreProduct
              }
            >
              +
            </Button>

          </div>

          {/* =================================================
              BOTTOM
          ================================================= */}

          <Row className="mt-3">

            {/* LEFT */}

            <Col md="6">

              <Row>

                <Col md="6">

                  <Label>
                    Invoice Number
                  </Label>

                  <Input
                    name="invoiceId"
                    onChange={
                      HandleUpdatePurchase
                    }
                  />

                </Col>

                <Col md="6">

                  <Label>
                    Builty Number
                  </Label>

                  <Input
                    name="BuiltyNumber"
                    onChange={
                      HandleUpdatePurchase
                    }
                  />

                </Col>

                <Col md="6">

                  <Label>
                    Dispatch Date
                  </Label>

                  <Input
                    type="date"
                    name="DispatchDate"
                    onChange={
                      HandleUpdatePurchase
                    }
                  />

                </Col>

                <Col md="6">

                  <Label>
                    No of Packages
                  </Label>

                  <Input
                    type="number"
                    name="NoOfPackage"
                    onChange={
                      HandleUpdatePurchase
                    }
                  />

                </Col>

                <Col md="6">

                  <Label>
                    Transporter
                  </Label>
                  <Input
                    type="select"
                    name="transporterId"
                    value={extraCharges?.transporterId || ""}
                    onChange={HandleUpdatePurchase}
                  >
                    <option value="">
                      ----Select Transporter----
                    </option>

                    {TransporterList.map((item) => (
                      <option
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </option>
                    ))}
                  </Input>

                </Col>

                <Col md="6">

                  <Label>
                    Vehicle Number
                  </Label>

                  <Input
                    name="vehicleNo"
                    onChange={
                      HandleUpdatePurchase
                    }
                  />

                </Col>

              </Row>

            </Col>

            {/* =================================================
                SUMMARY
            ================================================= */}

            <Col
              md="6"
              className="d-flex justify-content-end"
            >

              <div className="summary-box">

                <div>
                  Basic Total:{" "}
                  {Number(
                    GSTData?.Tax
                      ?.Amount || 0
                  ).toFixed(2)}
                </div>

                <div>
                  Charges:{" "}
                  {Number(
                    GSTData?.Tax
                      ?.Charges ||
                    Charges ||
                    0
                  ).toFixed(2)}
                </div>

                <div>
                  SGST:{" "}
                  {Number(
                    GSTData?.Tax
                      ?.SgstTotal ||
                    0
                  ).toFixed(2)}
                </div>

                <div>
                  CGST:{" "}
                  {Number(
                    GSTData?.Tax
                      ?.CgstTotal ||
                    0
                  ).toFixed(2)}
                </div>

                <div>
                  IGST:{" "}
                  {Number(
                    GSTData?.Tax
                      ?.IgstTotal ||
                    0
                  ).toFixed(2)}
                </div>

                <div>
                  Round Off:{" "}
                  {Number(
                    GSTData?.Tax
                      ?.RoundOff ||
                    0
                  ).toFixed(2)}
                </div>

                <hr />

                <h5>
                  Grand Total:{" "}
                  {Number(
                    GSTData?.Tax
                      ?.GrandTotal ||
                    0
                  ).toFixed(2)}
                </h5>

              </div>

            </Col>

          </Row>

          {/* =================================================
              SUBMIT
          ================================================= */}

          <div className="text-center mt-3">

            <Button
              color="primary"
              type="submit"
              disabled={
                Loading
              }
            >
              {Loading
                ? "Submitting..."
                : "Submit"}
            </Button>

          </div>

        </Form>

      </CardBody>
    </Card>
  );
};

export default CreatePurchaseInvoice;